import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'dev',
  appClientId: '5sajagi0nuvphgac876dqpcecc',
  region: 'us-west-2',
  identityPoolId: 'us-west-2:6f6a4533-cf61-4242-bc94-ca2992b9a652',
  userPoolId: 'us-west-2_9T6kQmL8Q',
  domain: 'drift-user-domain-account.auth.us-west-2.amazoncognito.com',
  driftApi: 'https://wm6ouz19ta.execute-api.us-west-2.amazonaws.com',
  redirectSignIn: 'https://dev.drift.slalom.com/home',
  redirectSignOut: 'https://dev.drift.slalom.com/home',
  features: {
    enablePersonasManagement: true,
    enableSystemPrompts: true,
    enableReviewers: true,
    enableNewAdvisor: true,
    enableOldAdvisor: true,
    enableSampleStyles: true,
    enableLibrary: true
  },
  enableMocks: true,
  enableWorkspaceMocks: false,
  isWorkspaceActivated: true,
  wsUriWithoutToken: 'wss://0ysdc2o72d.execute-api.us-west-1.amazonaws.com/$default/?token=',

  mockApi: 'https://fd10d811-e0ee-4c47-92cb-276d864d4145.mock.pstmn.io',
  mockApiKey: 'UE1BSy02N2I3N2QzZGY2MDEwZjAwMDFlZjJlZDctODgyMWM0MWMwY2QyNDYzMWMyNjRkY2FhOTM0ZWQ1M2MzMg==',
  mockedApiCalls: []
};
